import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

export const useMyProfileStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalXL,
    backgroundColor: tokens.colorNeutralBackground2,
    minHeight: "100vh",
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    padding: tokens.spacingVerticalXXL,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    marginBottom: tokens.spacingVerticalL,
    boxShadow: tokens.shadow4,
  },
  cardTitle: {
    margin: `0 0 ${tokens.spacingVerticalM} 0`,
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    borderBottom: `2px solid ${tokens.colorBrandForeground1}`,
    paddingBottom: tokens.spacingVerticalS,
  },
  userInfo: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
  },
  userInfoItem: {
    display: "flex",
    gap: tokens.spacingHorizontalS,
  },
  userInfoLabel: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
});
